module.exports = __webpack_public_path__ + "media/hurrapersonajefavorito.99ddbffb.mp3";